module.exports = __webpack_public_path__ + "static/img/pop_QR.d862c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geren/pop_QR.png
// module id = deHs
// module chunks = 1